import React from 'react';
import { BrowserRouter, Link, Route, Redirect } from 'react-router-dom';
import ProjectInfo from "./components/about/ProjectInfo";
import SubredditTopicsApp from './components/subredditTopics/SubredditTopicsApp';
import CommentViewerApp from './components/commentViewer/CommentViewerApp';
import {ROUTE_ROOT} from "./config";
import './App.css';
const classNames = require('classnames');

class App extends React.Component {

    constructor(props){
        super(props);

		this.routes = ["about", "topics", "comments"].map(routeName => ROUTE_ROOT + "#" + routeName);

		//Set selected tab based on initial URL path when loaded
        const currentPath = window.location.pathname + window.location.hash;
        const matchingRouteIndex = this.routes.findIndex(route => currentPath === route);
        this.state = {
            selectedTab: (matchingRouteIndex !== -1)? matchingRouteIndex : 1
        };
    }

    selectTab = (i) => {
        this.setState({selectedTab: i});
    };

    render() {
        const selected = this.state.selectedTab;
        const tabClasses = Array.from({length: 4}, (el, i) => {
			return classNames('tabs__tab', 'tabs__link-tab', {'tabs__tab--selected': selected === i});
        });

        return (
            <BrowserRouter>
                <div className='wutbot-root'>
                  <nav className='tabs'>
              		<Link to={this.routes[0]} className={tabClasses[0]} onClick={() => this.selectTab(0)}>
						<div className='tabs__tab-content'>About</div>
                    </Link>

                    <Link to={this.routes[1]} className={tabClasses[1]} onClick={() => this.selectTab(1)}>
						<div className='tabs__tab-content'>Subreddit Topics</div>
                    </Link>

                    <Link to={this.routes[2]} className={tabClasses[2]} onClick={() => this.selectTab(2)}>
						<div className='tabs__tab-content'>Comment WSD</div>
                    </Link>

                    <a className={`${tabClasses[3]} tabs__link-tab-external`} href='https://www.reddit.com/r/WutbotPosts/' target='blank'>
                        <div className='tabs__tab-content'>
                            <span>Reddit Bot </span>
                            <span className='glyphicon glyphicon-link'/>
                        </div>
                    </a>
                  </nav>

                  <div className='wutbot-root__content'>
					<HashRoute path={this.routes[0]} component={ProjectInfo}/>
					<HashRoute path={this.routes[1]} component={SubredditTopicsApp}/>
					<HashRoute path={this.routes[2]} component={CommentViewerApp}/>
					<Redirect from='/' to={this.routes[this.state.selectedTab]}/>
                  </div>
                </div>
            </BrowserRouter>
        );
  }
}

//https://stackoverflow.com/questions/42033960/is-it-possible-to-match-the-part-of-a-route-in-react-router-4
const HashRoute = ({ component: Component, path, ...routeProps }) => {
	return (
	  <Route
		{...routeProps}
		component={({ location, ...props }) =>
			{
				return (location.pathname + location.hash) === path && <Component {...props}/>;
			}
		}
	   />
	);
};

export default App;


// WEBPACK FOOTER //
// ./src/App.js